import { createFileRoute } from '@tanstack/react-router'
import { AdminPolicyPage } from '@/features/policy/pages/admin-policy-page'

export const Route = createFileRoute('/policy')({
  staticData: { title: 'Policy' },
  component: AdminPolicyPage,
})
